import { useRef, useEffect } from 'react';
import { GameId } from '@bg-shared/enums/GameId';
import { currentResultService } from '@bg-shared/business/CurrentResult';
import { gamesMessagesEntity } from '@bg-shared/business/GamesMessages';
import { t } from '@bg-shared/business/Translate';
import { GameMessagePlacement } from '@bg-shared/business/GamesMessages/enums';

const MESSAGE_TIMEOUT = 5000; // ms

export const useGameItemCanceled = (gameId: GameId, drawCode: string) => {
    const drawCodeRef = useRef<string>();
    drawCodeRef.current = drawCode;

    useEffect(
        () =>
            currentResultService.subscribeCanceled(gameId, (data) => {
                if (drawCodeRef.current !== data.runCode) {
                    return;
                }

                gamesMessagesEntity.addToQueue(
                    {
                        message: t.string('fixing_technical_issue'),
                        timeout: MESSAGE_TIMEOUT,
                    },
                    GameMessagePlacement.TOP,
                );
            }),
        [],
    );
};
